import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex)

const state = {
  sidebarShow: 'responsive',
  sidebarMinimize: false,
  user: {},
  menu: [],
}

const mutations = {
  toggleSidebarDesktop (state) {
    const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarOpened ? false : 'responsive'
  },
  toggleSidebarMobile (state) {
    const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
    state.sidebarShow = sidebarClosed ? true : 'responsive'
  },
  set (state, [variable, value]) {
    state[variable] = value
  },
}

const getters = {
  hasRole(state, role) {
    let has = state.user.roles.filter(function(v){
      if (v.name === role)
        return true
    })
    return has.length > 0
  },

  hasAnyRole: (state) => (roles) => {
    let has = state.user.roles.filter(function(v){
        return roles.includes(v.name)
    })
    return has.length > 0
  }
}

export default new Vuex.Store({
  state,
  plugins: [createPersistedState()],
  mutations,
  getters,
})